import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownHotelSecondaryServices', request)
}

export {get}
